import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const CountriesWithOLFPage = lazy(() => import("@/pages/ReferenceBooks/Lists/LegalEntityRequisites/CountriesWithOLF/CountriesWithOLFPage"));
const OLFsByCountryIdPage = lazy(() => import("@/pages/ReferenceBooks/Lists/LegalEntityRequisites/CountriesWithOLF/OLFsByCountryIdPage"));
const CountriesWithRequisitesPage = lazy(() => import("@/pages/ReferenceBooks/Lists/LegalEntityRequisites/CountriesWithRequisites/CountriesWithRequisitesPage"));
const RequisitesByCountryIdPage = lazy(() => import("@/pages/ReferenceBooks/Lists/LegalEntityRequisites/CountriesWithRequisites/RequisitesByCountryIdPage"));
const OLFToRequisiteRulesPage = lazy(() => import("@/pages/ReferenceBooks/Lists/LegalEntityRequisites/OLFToRequisiteRules/OLFToRequisiteRulesPage"));

const urlsConfig = new UrlsConfig();

export function referenceBookLegalRequisitesRoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBookCountriesLegalForms.to}
                 element={<CountriesWithOLFPage/>}/>
          <Route path={`${urlsConfig.referenceBookCountriesLegalForms.to}/:countryId`}
                 element={<OLFsByCountryIdPage/>}/>

          <Route path={urlsConfig.referenceBookCountriesRequisites.to}
                 element={<CountriesWithRequisitesPage/>}/>
          <Route path={`${urlsConfig.referenceBookCountriesRequisites.to}/:countryId`}
                 element={<RequisitesByCountryIdPage/>}/>

          <Route path={urlsConfig.referenceBookLegalFormRequisiteRules.to}
                 element={<OLFToRequisiteRulesPage/>}/>
      </>
    );
}
